import { setAuthState, setSignInErrorMessage } from '@/store';
import { AuthType, TokenInfo } from '@/models';

const RESERVE = 5 * 1000;

export interface ITokenService {
  authType?: AuthType;
  remove: () => void;
  setRefreshing: (isRefreshing: boolean) => void;
  saveAuthData: (tokenInfo: TokenInfo) => void;
}

export class TokenService implements ITokenService {
  static tokenInfoKey = 'token';
  private _authType: AuthType = 'okta';

  get authType() {
    return this._authType;
  }

  static get = (): TokenInfo | null => {
    const tokenString = localStorage.getItem(this.tokenInfoKey);
    const tokenInfo: TokenInfo = tokenString ? JSON.parse(tokenString) : undefined;

    if (tokenInfo) {
      const msUTC = Date.parse(tokenInfo.expirationUtc);
      const msNow = Date.now();

      tokenInfo.isExpired = msUTC - RESERVE < msNow;

      return tokenInfo;
    }

    return null;
  };

  static set = (tokenInfo: TokenInfo | null) => {
    localStorage.setItem(this.tokenInfoKey, JSON.stringify(tokenInfo));
  };

  remove = () => {
    TokenService.set(null);
  };

  setRefreshing = (isRefreshing: boolean) => {
    const tokenInfo = TokenService.get();
    tokenInfo && TokenService.set({ ...tokenInfo, isRefreshing });
  };

  saveAuthData = (tokenInfo: TokenInfo) => {
    this._authType = tokenInfo.authType;
    TokenService.set(tokenInfo);

    setAuthState({ authorized: true });
    setSignInErrorMessage('');
  };
}
